import { render, staticRenderFns } from "./RedirectTo.vue?vue&type=template&id=a6fa74b8&"
import script from "./RedirectTo.vue?vue&type=script&lang=js&"
export * from "./RedirectTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports